import { render, staticRenderFns } from "./TotalPayment.vue?vue&type=template&id=f6113cb0&"
import script from "./TotalPayment.vue?vue&type=script&lang=js&"
export * from "./TotalPayment.vue?vue&type=script&lang=js&"
import style0 from "./TotalPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports